import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {LessonsPageComponent} from './pages/lessons-page/lessons-page.component';
import {UtilsModule} from '../utils/utils.module';
import {StudentLessonsComponent} from './components/student/student-lessons/student-lessons.component';
import {FormsModule} from '@angular/forms';
import {
  StudentLessonDetailsPageComponent
} from './pages/student-lesson-details-page/student-lesson-details-page.component';
import {
  StudentLessonDetailsComponent
} from './components/student/student-lesson-details/student-lesson-details.component';
import {AppRoutingModule} from '../app-routing.module';
import {CourseCardComponent} from './components/student/course-card/course-card.component';
import {CourseProductsPageComponent} from './pages/course-products-page/course-products-page.component';
import {SpanishProductsComponent} from './components/student/products/spanish-products/spanish-products.component';
import {EnglishProductsComponent} from './components/student/products/english-products/english-products.component';
import {
  EnglishBusinessProductsComponent
} from './components/student/products/english-business-products/english-business-products.component';
import {KidsProductsComponent} from './components/student/products/kids-products/kids-products.component';
import {ProductBoxComponent} from './components/student/products/product-box/product-box.component';
import {CspaModule} from '../cspa/cspa.module';
import {StudentCreditsComponent} from './components/student/student-credits/student-credits.component';
import {TransactionsComponent} from './components/student/transactions/transactions.component';
import {PurchaseHistoryComponent} from './components/student/purchase-history/purchase-history.component';
import {ProgressCardComponent} from './components/student/progress-card/progress-card.component';
import {ReserveLessonComponent} from './components/student/reserve-lesson/reserve-lesson.component';
import {StudentMainCalendarComponent} from './components/student/student-main-calendar/student-main-calendar.component';
import {WeekCalendarComponent} from './components/week-calendar/week-calendar.component';
import {TeachersListComponent} from './components/student/teachers-list/teachers-list.component';
import {TeacherDashboardPageComponent} from './pages/teacher/teacher-dashboard-page/teacher-dashboard-page.component';
import {TeacherLessonsComponent} from './components/teacher/teacher-lessons/teacher-lessons.component';
import {
  TeacherDashboardLessonsDetailsPageComponent
} from './pages/teacher/teacher-dashboard-lessons-details-page/teacher-dashboard-lessons-details-page.component';
import {
  TeacherLessonDetailsHeaderComponent
} from './components/teacher/teacher-lesson-details-header/teacher-lesson-details-header.component';
import {
  LessonCommitedProgressComponent
} from './components/teacher/lesson-commited-progress/lesson-commited-progress.component';
import {LessonHistoryComponent} from './components/teacher/lesson-history/lesson-history.component';
import {TeacherLessonsPageComponent} from './pages/teacher/teacher-lessons-page/teacher-lessons-page.component';
import {
  TeacherLessonDetailsPageComponent
} from './pages/teacher/teacher-lesson-details-page/teacher-lesson-details-page.component';
import {
  TeacherLessonDetailsComponent
} from './components/teacher/teacher-lesson-details/teacher-lesson-details.component';
import {TeacherMainCalendarComponent} from './components/teacher/teacher-main-calendar/teacher-main-calendar.component';
import {
  TeacherQuickLessonCounterComponent
} from './components/teacher/teacher-quick-lesson-counter/teacher-quick-lesson-counter.component';
import {ShoppingCartComponent} from './components/shopping-cart/shopping-cart/shopping-cart.component';
import {
  ShoppingCartProductComponent
} from './components/shopping-cart/shopping-cart-product/shopping-cart-product.component';
import {
  ShoppingCartHeaderComponent
} from './components/shopping-cart/shopping-cart-header/shopping-cart-header.component';
import {OrderFailComponent} from './pages/order-fail/order-fail.component';
import {OrderSuccessComponent} from './pages/order-success/order-success.component';
import { ProgressPageComponent } from './pages/student/progress-page/progress-page.component';
import { ReserveLessonPageComponent } from './pages/student/reserve-lesson-page/reserve-lesson-page.component';
import { CreditsPageComponent } from './pages/credits-page/credits-page.component';
import { LessonCardComponent } from './components/lesson-card/lesson-card.component';
import { TeacherListPageComponent } from './pages/teacher-list-page/teacher-list-page.component';
import {
  EnglishBusinessCourseComponent
} from "./components/courses/english-business-course/english-business-course.component";
import {KidsCourseComponent} from "./components/courses/kids-course/kids-course.component";
import {EnglishCourseComponent} from "./components/courses/english-course/english-course.component";
import {SpanishCourseComponent} from "./components/courses/spanish-course/spanish-course.component";
import { CoursesPageComponent } from './pages/courses-page/courses-page.component';
import { ProgressCardShortComponent } from './components/student/progress-card-short/progress-card-short.component';
import { ProgressCardListComponent } from './components/student/progress-card-list/progress-card-list.component';
import { StudentCreditsShortComponent } from './components/student/student-credits-short/student-credits-short.component';
import { StudentLessonsCalendarComponent } from './components/student/student-lessons-calendar/student-lessons-calendar.component';
import { CalendarTeacherFilterModalComponent } from './components/student/calendar-teacher-filter-modal/calendar-teacher-filter-modal.component';
import {
  PrepareToConnectTabComponent
} from "./components/student/prepare-to-connect-tab/prepare-to-connect-tab.component";
import {PreProvaQuizComponent} from "./components/student/pre-prova-quiz/pre-prova-quiz.component";
import {StarterPlanPageComponent} from './pages/starter-plan-page/starter-plan-page.component';
import {StarterProductCardComponent} from './components/student/products/starter-product-card/starter-product-card.component';


@NgModule({
  declarations: [
    LessonsPageComponent,
    StudentLessonsComponent,
    StudentLessonDetailsPageComponent,
    StudentLessonDetailsComponent,
    CourseCardComponent,
    CourseProductsPageComponent,
    SpanishProductsComponent,
    EnglishProductsComponent,
    EnglishBusinessProductsComponent,
    KidsProductsComponent,
    ProductBoxComponent,
    StudentCreditsComponent,
    TransactionsComponent,
    PurchaseHistoryComponent,
    ProgressCardComponent,
    ReserveLessonComponent,
    StudentMainCalendarComponent,
    WeekCalendarComponent,
    TeachersListComponent,
    TeacherDashboardPageComponent,
    TeacherLessonsComponent,
    TeacherDashboardLessonsDetailsPageComponent,
    TeacherLessonDetailsHeaderComponent,
    TeacherLessonDetailsComponent,
    LessonCommitedProgressComponent,
    LessonHistoryComponent,
    TeacherLessonsPageComponent,
    TeacherLessonDetailsPageComponent,
    TeacherMainCalendarComponent,
    TeacherQuickLessonCounterComponent,
    ShoppingCartComponent,
    ShoppingCartProductComponent,
    ShoppingCartHeaderComponent,
    OrderFailComponent,
    OrderSuccessComponent,
    ProgressPageComponent,
    ReserveLessonPageComponent,
    CreditsPageComponent,
    LessonCardComponent,
    TeacherListPageComponent,
    EnglishBusinessCourseComponent,
    KidsCourseComponent,
    EnglishCourseComponent,
    SpanishCourseComponent,
    CoursesPageComponent,
    ProgressCardShortComponent,
    ProgressCardListComponent,
    StudentCreditsShortComponent,
    StudentLessonsCalendarComponent,
    CalendarTeacherFilterModalComponent,
    PrepareToConnectTabComponent,
    PreProvaQuizComponent,
    StarterPlanPageComponent,
    StarterProductCardComponent
  ],
    imports: [
        CommonModule,
        AppRoutingModule,
        UtilsModule,
        FormsModule,
        CspaModule,
        NgOptimizedImage
    ],
    exports: [
        LessonCardComponent,
        ProgressCardShortComponent,
        ProgressCardComponent,
        ProgressCardListComponent,
        StudentCreditsShortComponent,
        StudentMainCalendarComponent,
        StudentLessonsCalendarComponent
    ]
})
export class ColModule { }
